import getReviewsRouteData from "./get-reviews-route";
import postReviewRoutesData from "./post-review-route";
import getTestimonialReviewsRouteData from "./get-testimonial-reviews-route";

export default {
  "get-reviews": getReviewsRouteData,
  "get-testimonial-reviews": getTestimonialReviewsRouteData,
  "post-review": postReviewRoutesData,
};
